export default __webpack_public_path__ + "static/media/BHS_colour_logo.630ee362.svg";